import { useMutation } from '@tanstack/react-query';
import { useUnit } from 'effector-react';

import {
  AcquisitionType,
  OnboardingFlow,
  ProfileFieldSource,
} from '@m/types/grpc/MemberOnboardingSource';
import { verifyAndRegister, userStore } from 'apps/customer/state/user';
import { visitStore } from 'apps/customer/state/visit';

import type { UseMutationOptions } from '@tanstack/react-query';
import type { VerifyAndRegisterResult } from 'apps/customer/state/user/actions';

type VerifyPhoneArgs = { otp: string; siteUuid?: string };

export function useVerifyPhone(
  options?: UseMutationOptions<VerifyAndRegisterResult, Error, VerifyPhoneArgs>,
) {
  const { phoneNumber } = useUnit(userStore);
  const { qrValidation } = useUnit(visitStore);

  return useMutation({
    mutationFn: ({ otp, siteUuid }: VerifyPhoneArgs) =>
      verifyAndRegister({
        phoneNumber,
        code: otp,
        beginSession: true,
        acquisitionType: AcquisitionType.ORGANIC,
        onboardingFlow: OnboardingFlow.EXPRESS,
        profileFieldSource: qrValidation
          ? ProfileFieldSource.VALIDATION_FLOW
          : ProfileFieldSource.EXPRESS_ONBOARDING,
        siteUuid,
      }),
    ...options,
  });
}
